<template>
  <div class="d-flex align-center gap-1">
    <tm-icon
      :name="icon"
      size="size15"
      color="gray7"
    />

    <span class="font-size-small font-weight-semi-bold">
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@/assets/icons/icons'
import TmIcon from '@/components/shared/TmIcon.vue'

defineProps<{
  label: string
  icon: IconName
}>()
</script>
